"use client";

import React from "react";
import {
  VideoSource,
  VideoMetadata,
  VideoPlayerConfig,
  VideoPlayerEvents,
  VideoSourceType,
  DeviceType,
} from "@interfaces/video";
import S3VideoPlayer from "./S3VideoPlayer";
import YouTubeIframePlayer from "./YouTubeIframePlayer";

interface VideoPlayerProps {
  video: VideoSource;
  metadata: VideoMetadata;
  config?: VideoPlayerConfig;
  events?: VideoPlayerEvents;
  deviceType: DeviceType;
  isVisible: boolean;
  className?: string;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  video,
  metadata,
  config = {},
  events = {},
  deviceType,
  isVisible,
  className,
}) => {
  // Route to appropriate player based on video type
  const isYouTubeVideo =
    video.type === VideoSourceType.YOUTUBE ||
    video.type === VideoSourceType.YOUTUBE_SHORTS;

  if (isYouTubeVideo) {
    return (
      <YouTubeIframePlayer
        video={video}
        metadata={metadata}
        config={config}
        events={events}
        deviceType={deviceType}
        isVisible={isVisible}
        className={className}
      />
    );
  }

  // Default to S3 video player for S3_DIRECT and other types
  return (
    <S3VideoPlayer
      video={video}
      metadata={metadata}
      config={config}
      events={events}
      deviceType={deviceType}
      isVisible={isVisible}
      className={className}
    />
  );
};

export default VideoPlayer;
